import { ButtonTheme } from 'builder/components/Button'
import * as Styles from './styles'

type Props = {
  text?: string
  approveButtonText: string
  rejectButtonText: string
  rejectButtonClick: () => void
  approveButtonClick: () => void
}

export const BannerActions = ({
  text,
  approveButtonText,
  rejectButtonText,
  rejectButtonClick,
  approveButtonClick,
}: Props) => {
  return (
    <Styles.Container>
      <Styles.InfoContainer>
        {text && <Styles.Text dangerouslySetInnerHTML={{ __html: text }} />}
      </Styles.InfoContainer>
      <Styles.ActionsContainer>
        <Styles.ActionButton onClick={approveButtonClick} theme={ButtonTheme.ghost}>
          {approveButtonText}
        </Styles.ActionButton>
        <Styles.ActionButton onClick={rejectButtonClick}>{rejectButtonText}</Styles.ActionButton>
      </Styles.ActionsContainer>
    </Styles.Container>
  )
}
